import React, { useEffect, useState } from "react"

import {
    Card,
    CardBody,
    Col,
    Row,
    CardTitle,
    FormGroup,
    Form
} from "reactstrap"

import { connect } from "react-redux";
import { useDispatch } from 'react-redux'
import Select from "react-select";

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
import { createUser } from "helpers/user_helper";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Loader from "components/Loader/Loader";
import { getAllUserTypes } from "helpers/userTypeHelper";






const CreateUser = (props) => {
    document.title = "Question Bank | Create User";
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [mobile, setMobile] = useState("");
    const [type, setType] = useState({});
    const [depot, setDepot] = useState({});
    const [allUserTypes, setAllUserTypes] = useState([]);
    const [isReadOnly, setIsReadOnly] = useState(false);
    const [spanDisplay, setSpanDisplay] = useState("none");
    const [loader, setLoader] = useState(false);
    const result = useSelector(state => state.userReducer);
    const dispatch = useDispatch();




    const breadcrumbItems = [
        { title: "User", link: "#" },
        { title: "Create User", link: "#" },
    ]
    useEffect(() => {           /* For closing the sidebar if opened */
        const blurDiv = document.getElementById("blur");
        var width = window.innerWidth;
        if (width <= 994) {
            blurDiv.click()
        }
    }, [])

    useEffect(() => {
        props.setBreadcrumbItems('Create User', breadcrumbItems)
    })

    useEffect(() => {
        fetchUserTypes();
    }, [])

    const fetchUserTypes = async () => {
        try {

            const result = await getAllUserTypes();
            setAllUserTypes(result?.result);
        } catch (error) {
            toast.error(error?.responsive?.data?.message);
        }
    }





    const handleSubmit = async (e) => {
        e.preventDefault();

        const mobileRegex = /^\d{10}$/; // Adjust the regex as per your mobile number format requirements

        if (!name || !email || !mobile || !type || !password || !confirmPassword) {
            setSpanDisplay("inline")

        } else if (!mobileRegex.test(mobile)) {
            toast.error("Please enter a valid mobile number (10 digits).");
            return; // Exit early if the mobile number is invalid
        }
        if (type.name == "Tata Depot Manager" && !depot) {
            toast.error("Please select a depot");
            setSpanDisplay("inline");
            return;

        }
        else {
            if (password !== confirmPassword) {
                toast.error("Pasword and confirm password did not match");
            }
            else {
                // dispatch(add)
                try {
                    let userTypeDto = type;


                    setLoader(true);
                    let tataUserDetailsDto = { depot: depot.name }
                    const data = await createUser({ name, email, mobile, password, userTypeDto, tataUserDetailsDto });
                    setLoader(false);
                    if (data?.success) {
                        toast.success(data?.message);
                        setName("")
                        setEmail("")
                        setMobile("")
                        setPassword("")
                        setConfirmPassword("");
                        setType({});
                        setDepot({});
                    }
                    else {
                        toast.error(data?.message)
                    }
                } catch (error) {
                    setLoader(false);
                    toast.error(error?.response?.data?.message);
                }

            }
        }
    };



    const handleSelectType = selectedValue => {
        // console.log(selectedValue);
        setType(selectedValue);
    }

    const handleSelectDepot = selectedValue => {
        // console.log(selectedValue);
        setDepot(selectedValue);
    }


    const depotData = [
        { id: 1, name: "BBM" },
        { id: 2, name: "Backbay" },
        { id: 3, name: "Bawana" },
        { id: 4, name: "Bhagwati Nagar" },
        { id: 5, name: "Deepanjali Nagar" },
        { id: 6, name: "Dichaon Kalan" },
        { id: 7, name: "Dwarka-8" },
        { id: 8, name: "GTK" },
        { id: 9, name: "Hari Nagar-2" },
        { id: 10, name: "Hasanpur" },
        { id: 11, name: "Hennur" },
        { id: 12, name: "Indraprastha" },
        { id: 13, name: "Jayanagar" },
        { id: 14, name: "Jigani" },
        { id: 15, name: "K R Puram" },
        { id: 16, name: "Kalkaji" },
        { id: 17, name: "Kalinga Nagar" },
        { id: 18, name: "Kannalli" },
        { id: 19, name: "Malwani" },
        { id: 20, name: "Mayapuri" },
        { id: 21, name: "Mera Mandali" },
        { id: 22, name: "Mundela Kalan" },
        { id: 23, name: "Nand Nagri" },
        { id: 24, name: "Narela" },
        { id: 25, name: "Naraina" },
        { id: 26, name: "Naranpura" },
        { id: 27, name: "Nehru Place" },
        { id: 28, name: "Okhla" },
        { id: 29, name: "Online" },
        { id: 30, name: "Pantnagar" },
        { id: 31, name: "Pantha Chowk" },
        { id: 32, name: "Peenya" },
        { id: 33, name: "Rohini-1" },
        { id: 34, name: "Rohini-2" },
        { id: 35, name: "Sarojini Nagar" },
        { id: 36, name: "Shanti Nagar" },
        { id: 37, name: "Shivaji Nagar" },
        { id: 38, name: "Subhash Place" },
        { id: 39, name: "Sukhdev Vihar" },
        { id: 40, name: "Tekhand" },
        { id: 41, name: "Tss" },
        { id: 42, name: "Wazirpur" },
        { id: 43, name: "Worli" }
    ];





    return (
        <React.Fragment>
            {loader ? (
                <Loader />
            ) : ("")}
            <Row>
                <Col>
                    <Card>
                        <CardBody className="col-xl-10 col-lg-10 col-md-10 col-sm-12 col-xs-12">
                            <CardTitle className="h4">Create User</CardTitle>
                            <form onSubmit={handleSubmit}>

                                <Row className="mb-3">
                                    <label
                                        htmlFor="example-text-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        Name
                                    </label>
                                    <div className="col-md-10">
                                        <input type="text"
                                            className='form-control'
                                            placeholder="Enter User Name"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)} />
                                        {!name && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}

                                    </div>
                                </Row>
                                <Row className="mb-3">
                                    <label
                                        htmlFor="example-text-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        Email
                                    </label>
                                    <div className="col-md-10">
                                        <input type="text"
                                            className='form-control'
                                            placeholder="Enter Email Id"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)} readOnly={isReadOnly} />
                                        {!email && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                                    </div>
                                </Row>

                                <Row className="mb-3">
                                    <label
                                        htmlFor="example-text-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        Phone Number
                                    </label>
                                    <div className="col-md-10">
                                        <input type="text"
                                            className='form-control'
                                            placeholder="Enter Phone Number"
                                            value={mobile}
                                            onChange={(e) => setMobile(e.target.value)} />
                                        {!mobile && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                                    </div>
                                </Row>

                                <Row className="mb-3">
                                    <label
                                        htmlFor="example-text-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        User Type
                                    </label>
                                    <div className="col-md-10">
                                        <Select

                                            value={type}
                                            onChange={handleSelectType}
                                            options={allUserTypes}
                                            getOptionLabel={option => option.name}
                                            getOptionValue={option => option.id}
                                            classNamePrefix="select2-selection"
                                        />
                                        {!type && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                                    </div>

                                </Row>
                                {type.name == "Tata Depot Manager" &&
                                    <Row className="mb-3">
                                        <label
                                            htmlFor="example-text-input"
                                            className="col-md-2 col-form-label"
                                        >
                                            Depot
                                        </label>
                                        <div className="col-md-10">
                                            <Select

                                                value={depot}
                                                onChange={handleSelectDepot}
                                                options={depotData}
                                                getOptionLabel={option => option.name}
                                                getOptionValue={option => option.id}
                                                classNamePrefix="select2-selection"
                                            />
                                            {!depot && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                                        </div>

                                    </Row>
                                }

                                <Row className="mb-3">
                                    <label
                                        htmlFor="example-text-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        Password
                                    </label>
                                    <div className="col-md-10">
                                        <input type="text"
                                            className='form-control'
                                            placeholder="Enter Password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)} />
                                        {!password && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                                    </div>
                                </Row>

                                <Row className="mb-3">
                                    <label
                                        htmlFor="example-text-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        Confirm Password
                                    </label>
                                    <div className="col-md-10">
                                        <input type="text"
                                            className='form-control'
                                            placeholder="Enter Confirm Password"
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)} />
                                        {!confirmPassword && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                                    </div>
                                </Row>

                                <Row className="mb-3">
                                    <div className="mt-4">
                                        <button type="submit" className="btn btn-primary w-md">Submit</button>
                                    </div>
                                </Row>
                                {/* </>} */}
                            </form>

                        </CardBody>
                    </Card>
                </Col>
            </Row>



        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(CreateUser);